"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgGithub(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 0C5.374 0 0 5.509 0 12.303c0 5.436 3.438 10.048 8.207 11.675.599.114.793-.267.793-.591v-2.29c-3.338.744-4.033-1.453-4.033-1.453-.546-1.422-1.333-1.8-1.333-1.8-1.089-.764.083-.747.083-.747 1.205.086 1.839 1.268 1.839 1.268 1.07 1.88 2.807 1.337 3.492 1.022.107-.795.418-1.338.762-1.645-2.665-.312-5.467-1.367-5.467-6.08 0-1.345.469-2.442 1.236-3.303-.124-.31-.535-1.562.117-3.256 0 0 1.008-.33 3.301 1.26.957-.272 1.983-.408 3.003-.413 1.02.005 2.047.141 3.006.414 2.291-1.591 3.297-1.261 3.297-1.261.653 1.695.242 2.946.118 3.256.77.861 1.235 1.96 1.235 3.303 0 4.725-2.807 5.766-5.479 6.07.43.382.823 1.13.823 2.278v3.377c0 .327.192.711.801.59C20.566 22.348 24 17.737 24 12.303 24 5.51 18.627 0 12 0z",
    fill: "inherit",
    fillRule: "nonzero"
  }));
}

var _default = SvgGithub;
exports.default = _default;